// @flow
import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: 'alert.title',
        defaultMessage: 'Thank you'
    },
    hello: {
        id: 'alert.hello',
        // eslint-disable-next-line max-len
        defaultMessage: 'Hello'
    },
    thankYouMessage: {
        id: 'alert.thank-you-message',
        // eslint-disable-next-line max-len
        defaultMessage:
            'We just wanted to say a big thank you to everyone who has sent us feedback over the past couple of weeks. Your feedback is really appreciated, and helps us keep the app reliable and easy to use as we add new and exciting smart features.'
    },
    changeMessage: {
        id: 'alert.change-message',
        // eslint-disable-next-line max-len
        defaultMessage:
            'We have taken your comments on board and will continue to improve the app further over the coming weeks.'
    },
    thanksAgain: {
        id: 'alert.thanks-again',
        defaultMessage: 'Thanks again, {break} The Hive Team'
    },
    ok: {
        id: 'alert.ok',
        defaultMessage: 'Ok'
    }
});



// WEBPACK FOOTER //
// ./src/components/widgets/new-website-popup/intl.js